module.exports = __webpack_public_path__ + "img/banner-1.dafbc8a0.jpg";